@import 'src/styles/variabels';
@import 'src/styles/mobile';

.root {
  color: #fff;
}
.item {
  text-transform: capitalize;
  justify-content: center;
}

// N1 / T2: below md the switch sits in the drawer's white footer, not on the
// desktop's blue rail: one segmented pair of 44 px segments, the current
// language white on the product blue as the desktop rail shows it. Doubled
// classes: MUI's own MenuList / MenuItem styles are emotion classes of the
// same weight, injected after this sheet. Physical sides are written LTR;
// postcss-rtl mirrors them.
@media (max-width: map-get($breakpoints, 'md') - 1 + px) {
  .root.root {
    display: flex;
    padding: 0;
    color: $color-primary;
  }
  .item.item {
    min-width: $mobile-tap;
    height: $mobile-tap;
    min-height: 0;
    padding: 0 $mobile-space-s;
    border: 1px solid $color-primary;
    font-weight: bold;
    &:first-child {
      border-radius: 0.4rem 0 0 0.4rem;
    }
    &:last-child {
      margin-left: -1px;
      border-radius: 0 0.4rem 0.4rem 0;
    }
    // with :hover too -- a tap leaves the touch hover state behind, and MUI's
    // selected-hover tint would repaint the segment
    &[class~='Mui-selected'],
    &[class~='Mui-selected']:hover {
      background-color: $color-primary;
      color: #fff;
    }
  }
}
